import { Store } from '../../types/model';
import { Page } from '../../types/Seo';
import { EVENT_LIST } from './enums';

export default function getEventListSeo(
  selectedStore: Store,
  page: Page,
  t: Function
) {
  const url = window.location.href;
  const path = url.replace(/^https?:\/\//, '').split('/');
  const setOtherstoreName = () => {
    if (selectedStore !== undefined) {
      if ((path[1] === "jp" || path[1] === "kr") && path[2] === "en") {
        return selectedStore.storeOtherName;
      } else {
        return selectedStore.storeName;
      }
    }
    return '';
  };
  
  const title = selectedStore
  ? t('event.storePageTitle', { storeName: setOtherstoreName() })
  : t('event.pageTitle');

  const description = selectedStore
    ? 'storeEventCustomer.storeDescription'
    : 'storeEventCustomer.listDescription';

  const meta = [
    {
      name: 'description',
      content: t(description, { storeName: setOtherstoreName() })
    },
  ];

  const robots =
    page === EVENT_LIST && !selectedStore
      ? [
          {
            name: 'robots',
            content: 'noindex',
          },
        ]
      : [
          {
            name: 'robots',
            content: 'index, follow',
          },
        ];

  return {
    jsonLd: null,
    meta: [...meta, ...robots],
    title,
    canonicalPath: null,
  };
}
